import React, { Component } from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import ShowSuccessToasts from '../../global/successToast';
import ShowErrorToasts from '../../global/errorToast';
import { ResetPasswordRequestSchema } from '../validation';
import { PAGE_ROUTES } from '../../../constants/pageRoutes';
import FloatingLabel from 'floating-label-react';
import { Link } from 'react-router-dom';

class TokenPasswordResetForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      emailSent: false
    }
    this.formSubmit = this.formSubmit.bind(this);
  }

  formSubmit(values, { setSubmitting }) {
    let { onSubmit } = this.props;
    this.setState({ emailSent: true });
    onSubmit(values, { setSubmitting });
  }

  render() {
    let { emailSent } = this.state;
    let initialValues = {
      email: ''
    }
    return (
      <div className="main-container">
        <ShowSuccessToasts />
        <ShowErrorToasts />
        <div className="main-wrapper">
          <div className="left-section">
            <div className="white-background">
              <div className="content-section">
                <h1 className="title">Request password reset</h1>
                <p className="detail-text">Please provide your email address and we'll send reset password instructions.</p>
                <Formik
                  validationSchema={ResetPasswordRequestSchema}
                  initialValues={initialValues}
                  onSubmit={this.formSubmit}>
                  {formProps => (
                    <Form>
                      <div className="signin-page">
                        <div className="form-section">
                          <div>
                            <div className="form-group">
                              <FloatingLabel
                                type="email"
                                id="email"
                                className="form-control"
                                name="email"
                                placeholder="Email Address"
                                value={formProps.values.email}
                                onChange={formProps.handleChange}
                              />
                              <ErrorMessage name='email' render={msg => <div className="invalid-feedback">{msg}</div>} />
                              {emailSent && (<div className="pl-3 pr-3 error-message error-green">Please check your email for a link to reset your password.</div>)}
                            </div>
                          </div>
                          <div className="combo-button">
                            <div className="signin-button">
                              <button type="submit" className="btn primary">Send Instructions</button>
                            </div>
                          </div>
                          <div className="no-account-detail">
                            <p className="account-text">Back to <Link to={PAGE_ROUTES.LOGIN} className="signup-link">Sign In</Link></p>
                          </div>
                        </div>
                      </div>
                    </Form>
                  )}
                </Formik>

              </div>
            </div>
          </div>
          <div className="right-section">
            <div className="bg-image"></div>
          </div>
        </div>
      </div >
    )
  }
}

export default TokenPasswordResetForm;
